import { today, yesterday } from '../lib/dateRange.js';

/* A single day, with Today/Yesterday shortcuts and a calendar for the rest.

   Unlike Call history's from–to range, queue performance is read a day at a
   time, so this picks one date. Native <input type="date"> supplies the
   calendar — no date library, CSP-safe. Future dates are barred; there are no
   calls yet to come. */
export default function DateSelect({ value, onChange }) {
  const todayStr = today();
  const yesterdayStr = yesterday();

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
      <div style={{ display: 'flex', gap: 6 }}>
        <button
          type="button"
          className="btn btn--filter"
          aria-pressed={value === todayStr}
          onClick={() => onChange(todayStr)}
        >
          Today
        </button>
        <button
          type="button"
          className="btn btn--filter"
          aria-pressed={value === yesterdayStr}
          onClick={() => onChange(yesterdayStr)}
        >
          Yesterday
        </button>
      </div>

      <label style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        <span style={{ fontFamily: 'var(--font-mono)', fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.04em', color: 'var(--ink-soft)' }}>
          Date
        </span>
        <input
          type="date"
          className="date-input"
          value={value}
          max={todayStr}
          onChange={(e) => e.target.value && onChange(e.target.value)}
        />
      </label>
    </div>
  );
}
